export enum ApiOrderDirection {
  DESC = 'Desc',
  ASC = 'Asc',
}
